import type { AppStateResponse, CommonsStats } from './types';

export type MutationResult = { ok: true; message?: string; data?: unknown } | { ok: false; error: string };

async function parseJson<T>(response: Response): Promise<T> {
  const body = (await response.json().catch(() => ({}))) as { error?: string } & T;
  if (!response.ok) {
    throw new Error(body.error ?? `Request failed: ${response.status}`);
  }
  return body as T;
}

export async function fetchState(deviceId: string): Promise<AppStateResponse> {
  const response = await fetch(`/api/state?deviceId=${encodeURIComponent(deviceId)}`);
  return parseJson<AppStateResponse>(response);
}

export async function fetchCommons(): Promise<CommonsStats> {
  const response = await fetch('/api/commons');
  return parseJson<CommonsStats>(response);
}

export async function postMutation(path: string, deviceId: string, token: string, payload: unknown): Promise<MutationResult> {
  try {
    const response = await fetch(`/api/${path}`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ deviceId, turnstileToken: token, ...(payload && typeof payload === 'object' ? payload : {}) })
    });
    return parseJson<MutationResult>(response);
  } catch (error) {
    return { ok: false, error: error instanceof Error ? error.message : 'Unknown error' };
  }
}
